// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('orderCustCom', {
//         templateUrl: 'views/components/views/orderCustCom/orderCustCom.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'orderCustComService', function ($stateParams, stateService, translateService, modalService, orderCustComService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orderCustComKeyno = $stateParams.ordercustcom_keyno;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 orderOrderNoButtons: [
//                     { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.edit.order_internal_no }) }
//                 ],
//                 statCustNameButtons: [
//                     { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('customersmenu', { cust_no: vm.model.edit.cust_no }) }
//                 ],
//                 customerTelephoneButtons: [
//                     { id: '$phone' }
//                 ],
//                 edit: {},
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION

//             async function loadEdit() {
//                 vm.model.edit = (await orderCustComService.getEdit({ ordercustcom_keyno: orderCustComKeyno }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 orderCustComService.saveObj(vm.model.edit).then((response) => {
//                     if (response[0] && response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 loadEdit();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
